module.exports = __webpack_public_path__ + "img/power.6306aba4.svg";